import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { useContext, useState } from 'react';
import ForgotPassword from '../ForgotPassword';
import { UserContext } from '../../App';
import { login } from '../../utils/Authentication';
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/esm/Spinner';
import CustomToast from '../CustomToast';
import { LOGIN_ADMIN, LOGIN_ORGANIZER } from '../../api/config';

function LoginForm({ role, setHeaderType, setIsAuthenticated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState('');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showResetPwSuccess, setShowResetPwSuccess] = useState(false);
  const [showResetPwFail, setShowResetPwFail] = useState(false);
  const navigate = useNavigate();

  const userContext = useContext(UserContext);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const data = {
      username: username,
      password: password,
    };

    const url = role === 'admin' ? LOGIN_ADMIN : LOGIN_ORGANIZER;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          setLoginError(false);
          return response.json();
        } else {
          setIsSubmitting(false);
          switch (response.status) {
            case 401:
              setLoginError(true);
              setLoginErrorMessage('E-post eller lösenord ej giltigt');
              break;
            default:
              setLoginError(true);
              setLoginErrorMessage('Något gick fel med inloggningen');
              break;
          }

          throw new Error('Could not sign in');
        }
      })
      .then(async (data) => {
        const user = await login(
          data.token,
          data.refreshToken,
          data.adminOrganizer
        );

        userContext.setUser(user);

        // Render correct header for organizer/admin
        if (user?.organizerAdmin === true) {
          setHeaderType(role);
        } else if (user?.organizerAdmin === false) {
          setHeaderType('organizerprofile');
        } else {
          setHeaderType(role);
        }
        setIsAuthenticated(true);

        if (role === 'organizer') {
          navigate('/organizer/competitions');
        } else {
          navigate('/admin/home');
        }
        setIsSubmitting(false);
      })
      .catch((text) => {
        //console.log(text);
      });
  };

  return (
    <div className='border p-4 w-100 bg-white rounded login-form'>
      {!forgotPassword ? (
        <Form
          onSubmit={handleSubmit}
          className='h-100 d-flex flex-column justify-content-between'
        >
          <div>
            <Form.Group className='mb-2' controlId='formEmail'>
              <Form.Label>E-post</Form.Label>
              <Form.Control
                className='p-2'
                type='email'
                placeholder='Ange e-post'
                onChange={(e) => setUsername(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='formPassword'>
              <Form.Label>Lösenord</Form.Label>
              <Form.Control
                className='p-2'
                type='password'
                placeholder='Ange lösenord'
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
          </div>

          <span
            onClick={() => setForgotPassword(true)}
            className='d-block fw-bold mt-1'
            role='button'
          >
            Glömt lösenord?
          </span>

          {loginError && (
            <Alert key='danger' variant='danger' className='mt-2 p-2 d-flex'>
              <span className='material-symbols-outlined me-2'>error</span>
              {loginErrorMessage}
            </Alert>
          )}

          <Button
            className='mt-3 w-100 d-flex justify-content-center align-items-center'
            variant='primary'
            type='submit'
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                  className='me-2'
                />
                <span className='visually-hidden'>Loading...</span>
                <span>Loggar in</span>
              </>
            ) : (
              <>
                <span className='material-symbols-outlined me-2'>login</span>
                <span>Logga in</span>
              </>
            )}
          </Button>
        </Form>
      ) : (
        <ForgotPassword
          showResetPwForm={setForgotPassword}
          onSuccess={() => setShowResetPwSuccess(true)}
          onFail={() => setShowResetPwFail(true)}
          role={role}
        />
      )}
      <CustomToast
        type='success'
        title='Återställningslänk skickad'
        body='En återställningslänk har skickats till angiven e-post'
        show={showResetPwSuccess}
        onClose={() => setShowResetPwSuccess(false)}
      />
      <CustomToast
        type='danger'
        title='Återställningslänk ej skickad'
        body='Kunde inte skicka återställningslänk till angiven e-post'
        show={showResetPwFail}
        onClose={() => setShowResetPwFail(false)}
      />
    </div>
  );
}

export default LoginForm;
